import React from 'react';
import { useQualificationOptionsWithLists } from '@/hooks/useQualificationOptions';
import { OptionListEditor } from '@/components/settings/qualification/OptionListEditor';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import { Loader2, Layers, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function QualificationOptionsSettings() {
  const { data: lists, isLoading, error } = useQualificationOptionsWithLists();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="destructive" className="max-w-2xl mx-auto mt-8">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          Erro ao carregar opções: {error.message}
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Layers className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Opções de Qualificação</h1>
          <p className="text-muted-foreground">
            Gerencie as opções de dropdown utilizadas no formulário de qualificação SDR
          </p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Listas de Opções</CardTitle>
          <CardDescription>
            Clique em uma categoria para expandir e editar suas opções
          </CardDescription>
        </CardHeader>
        <CardContent>
          {!lists || lists.length === 0 ? (
            <p className="text-muted-foreground text-center py-8">
              Nenhuma lista de opções encontrada
            </p>
          ) : (
            <Accordion type="single" collapsible className="w-full">
              {lists.map((list) => (
                <AccordionItem key={list.id} value={list.id}>
                  <AccordionTrigger className="hover:no-underline">
                    <div className="flex items-center gap-3 w-full">
                      <span className="font-medium">{list.name}</span>
                      <Badge variant="secondary" className="ml-auto mr-4">
                        {list.options?.filter(o => o.is_active).length || 0} opções ativas
                      </Badge>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="pt-4">
                      {list.description && (
                        <p className="text-sm text-muted-foreground mb-4">
                          {list.description}
                        </p>
                      )}
                      <OptionListEditor list={list} options={list.options || []} />
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
